<template>
  <div>
    <div style="margin: 10px 0">
      <el-input
        placeholder="请输入内容"
        v-model="title"
        clearable>
      </el-input>
    </div>

    <div style="margin: 10px 0">
      <div style="display: inline-block;width: 500px;margin-right: 20px">
        <el-select
          v-model="chooseTags"
          multiple
          filterable
          default-first-option
          placeholder="请选择文章标签"
          style="width: 100%">
          <el-option
            v-for="item in tags"
            :key="item.id"
            :label="item.tag_name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div style="display: inline-block;margin-right: 5px">置顶</div>
      <div style="display: inline-block;margin-right: 20px">
        <el-switch
          v-model="topping"
          active-color="dodgerblue"
          inactive-color="#909090">
        </el-switch>
      </div>

      <div style="display: inline-block;margin-right: 5px">精华</div>
      <div style="display: inline-block;margin-right: 20px">
        <el-switch
          v-model="essence"
          active-color="red"
          inactive-color="#909090">
        </el-switch>
      </div>

      <div style="display: inline-block;margin-right: 5px">隐私</div>
      <div style="display: inline-block;margin-right: 20px">
        <el-switch
          v-model="hidden"
          active-color="orange"
          inactive-color="#909090">
        </el-switch>
      </div>

      <div style="display: inline-block;float: right">
        <el-button type="success" plain @click="saveBlog">提交</el-button>
      </div>
    </div>

    <div style="margin-top: 30px">

      <MavonEditor ref="MavonEditor"></MavonEditor>

    </div>

  </div>
</template>

<script>

import MavonEditor from '../../../widgets/MavonEditor'
import {addBlog, createObjectID, getBlogTagList} from '../../../../../request/api'
export default {
  name: 'BackAddBlog',
  components: {MavonEditor},
  data () {
    return {
      id: '', // 创建ID
      title: '', // blog标题
      tags: [], // blog标签数据
      chooseTags: [], // blog输入的标签
      content: '', // blog内容
      topping: false, // 置顶
      essence: false, // 精华
      hidden: false // 隐私
    }
  },
  methods: {

    init () {
      // 获取ID
      createObjectID().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.id = res.data

          this.$refs.MavonEditor.blogid = this.id
          this.$refs.MavonEditor.defaultOpen = ''
          this.$refs.MavonEditor.toolbarsFlag = true
          this.$refs.MavonEditor.editable = true
          this.$refs.MavonEditor.subfield = true
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })

      getBlogTagList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.tags = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    },

    saveBlog () {
      if (this.id === '' || this.title === '' || this.$refs.MavonEditor.content === '') {
        this.$alert('请完善相关内容后再提交', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {

          }
        })
      } else {
        var params = {'blog_id': this.id, 'title': this.title, 'tags': this.chooseTags, 'content': this.$refs.MavonEditor.content, 'topping': this.topping, 'essence': this.essence, 'hidden': this.hidden}

        console.log(params)

        addBlog(params).then(res => {
          console.log(res)

          if (res.code === '90') {
            this.$message({
              type: 'success',
              message: '提交成功'
            })
            this.$router.push({path: '/blog/blog_info', name: 'BlogInfo', query: {blog_id: this.id}})
          } else {
            this.$message.error(res.msg)
          }
        }).catch((error) => {
          // error
          console.log(error)
        })
      }
    }

  },
  created () {
    this.init()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/blog/BackAddBlog.vue